import React from 'react';
import { Theme } from '../../../../Enums/Theme.enum';
import LinkButton from '../../../../Components/Button/LinkButton';
import useMedicalReport from '../../../MedicalReport/Hooks/useMedicalReport';
import { useFormContext } from 'react-hook-form';
import { useDisclose } from '../../../Modal/Hooks/useDisclose';
import DiscourseSelectModal from '../DiscourseSelect/DiscourseSelectModal';
import { DiscourseItem } from '../DiscourseHistory/DiscourseHistoryItem';
import { Document } from '../../../../graphql/graphql';
import { useAppContext } from '../../../../Services/AppContext';

export interface DiscourseTextLoadFields {
	text?: string;
	diagnoses?: string;
	diagnosisItemKey?: string;
	diagnosisMode?: 'array' | 'object';
	secondaryDiagnoses?: string;
	secondaryDiagnosisItemKey?: string;
}

interface Props {
	patientId: string;
	workplaceId?: string;
	className?: string;
	fields?: DiscourseTextLoadFields;
}

const DiscourseTextLoadButton: React.FC<Props> = ({
	patientId,
	workplaceId: workplaceIdProp,
	className,
	fields,
}) => {
	const { canLoadFromDiscourse, applyMedicalReportFormFromDocument } =
		useMedicalReport(patientId);
	const formMethods = useFormContext();
	const { workplaceId: workplaceIdFromContext } = useAppContext();
	const workplaceId = workplaceIdProp ?? workplaceIdFromContext;

	const {
		isOpen: isDiscourseSelectOpen,
		onOpen: onDiscourseSelectOpen,
		onClose: onDiscourseSelectClose,
	} = useDisclose();

	if (!canLoadFromDiscourse) return <></>;

	const handleSubmit = (item: DiscourseItem) => {
		applyMedicalReportFormFromDocument(formMethods, item as Document, fields);
		onDiscourseSelectClose();
	};

	return (
		<>
			<LinkButton
				onClick={onDiscourseSelectOpen}
				title='base.retrieveTextFromDecurse'
				theme={Theme.BLUE}
				className={className}
			/>

			{isDiscourseSelectOpen && (
				<DiscourseSelectModal
					isOpen
					onClose={onDiscourseSelectClose}
					patientId={patientId}
					workplaceId={workplaceId}
					onSubmit={handleSubmit}
				/>
			)}
		</>
	);
};

export default DiscourseTextLoadButton;
